// extracted by mini-css-extract-plugin
export default {"Changelog-author":"Changelog-authoroAHUL1T2vzwG"};